import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAxiosError } from 'axios';
import { userQueryOptions } from '@/hooks/queries/users.ts';
import { defineLabelQuery } from '@/lib/route-meta.ts';
import { parseUserId } from './+utils/parse-user-id.ts';

/**
 * Layout route for the `/users/$id` family. Validates the id param and primes
 * the single-user query here (loader pattern — the data depends only on the
 * route param), so the hub index, the details page, and the header breadcrumb /
 * document title all read the same cache entry via `userQueryOptions`. An
 * unknown/forbidden user (404/403) bounces back to the users list; a transient
 * failure is rethrown so the route errorComponent can offer a retry instead of
 * silently redirecting.
 */
export const Route = createFileRoute('/_logged/users/$id')({
  staticData: {
    labelQuery: (params) =>
      defineLabelQuery(userQueryOptions(Number(params.id)), (user) => user.username),
  },
  loader: async ({ context, params }) => {
    const userId = parseUserId(params.id);
    if (userId == null) throw redirect({ to: '/users' });
    try {
      await context.queryClient.ensureQueryData(userQueryOptions(userId));
    } catch (error) {
      const status = isAxiosError(error) ? error.response?.status : undefined;
      if (status === 404 || status === 403) throw redirect({ to: '/users' });
      throw error;
    }
  },
});
